import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Используем переменную
  timeout: 40000,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('jwtToken');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
  
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Если получаем 401 - убираем токен и редиректим на логин
      localStorage.removeItem("jwtToken");
      window.location.href = "/";
    }
    return Promise.reject(error);
  }
);


export default api;